// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.employee-interface {
  min-height: 100vh;
  background: linear-gradient(135deg, #1a1a2e, #16213e, #0f4c75);
  color: #fff;
}

.employee-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem 2rem;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.back-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
}

.back-button:hover {
  border-color: #00ff9f;
  box-shadow: 0 0 20px rgba(0, 255, 162, 0.3);
  transform: translateY(-2px);
}

.employee-header h1 {
  margin: 0;
  font-size: 2rem;
  background: linear-gradient(135deg, #00ff9f, #00b8ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: center;
  flex-grow: 1;
}

.employee-nav {
  display: flex;
  justify-content: center;
  gap: 1rem;
  padding: 1.5rem 2rem;
  background: rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.nav-button {
  padding: 12px 24px;
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1rem;
}

.nav-button:hover {
  border-color: rgba(0, 255, 162, 0.5);
  box-shadow: 0 0 15px rgba(0, 255, 162, 0.2);
  transform: translateY(-2px);
}

.nav-button.active {
  background: linear-gradient(135deg, #00ff9f, #00b8ff);
  color: #000;
  border-color: transparent;
  box-shadow: 0 5px 20px rgba(0, 255, 162, 0.4);
}

.nav-button.active:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 255, 162, 0.5);
}

.employee-content {
  padding: 0;
  min-height: calc(100vh - 140px);
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .employee-header {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
  
  .employee-header h1 {
    font-size: 1.5rem;
    order: -1;
  }
  
  .employee-nav {
    flex-wrap: wrap;
    padding: 1rem;
    gap: 0.8rem;
  }
  
  .nav-button {
    flex: 1 1;
    min-width: calc(50% - 0.4rem);
    padding: 12px 16px;
    font-size: 0.9rem;
  }
  
  .employee-content {
    padding: 0;
  }
}

@media (max-width: 480px) {
  .nav-button {
    min-width: 100%;
    margin-bottom: 0.5rem;
  }
  
  .employee-header {
    padding: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/EmployeeInterface.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,8DAA8D;EAC9D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,oCAAoC;EACpC,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,8BAA8B;EAC9B,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,UAAU;EACV,+BAA+B;AACjC;;AAEA,0BAA0B;AAC1B;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,aAAa;IACb,WAAW;EACb;;EAEA;IACE,SAAO;IACP,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".employee-interface {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #1a1a2e, #16213e, #0f4c75);\n  color: #fff;\n}\n\n.employee-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.5rem 2rem;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.back-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 12px 16px;\n  background: rgba(255, 255, 255, 0.1);\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  color: #fff;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n}\n\n.back-button:hover {\n  border-color: #00ff9f;\n  box-shadow: 0 0 20px rgba(0, 255, 162, 0.3);\n  transform: translateY(-2px);\n}\n\n.employee-header h1 {\n  margin: 0;\n  font-size: 2rem;\n  background: linear-gradient(135deg, #00ff9f, #00b8ff);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  text-align: center;\n  flex-grow: 1;\n}\n\n.employee-nav {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  padding: 1.5rem 2rem;\n  background: rgba(0, 0, 0, 0.2);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.nav-button {\n  padding: 12px 24px;\n  background: rgba(255, 255, 255, 0.1);\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  color: #fff;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 1rem;\n}\n\n.nav-button:hover {\n  border-color: rgba(0, 255, 162, 0.5);\n  box-shadow: 0 0 15px rgba(0, 255, 162, 0.2);\n  transform: translateY(-2px);\n}\n\n.nav-button.active {\n  background: linear-gradient(135deg, #00ff9f, #00b8ff);\n  color: #000;\n  border-color: transparent;\n  box-shadow: 0 5px 20px rgba(0, 255, 162, 0.4);\n}\n\n.nav-button.active:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 255, 162, 0.5);\n}\n\n.employee-content {\n  padding: 0;\n  min-height: calc(100vh - 140px);\n}\n\n/* Mobile Responsiveness */\n@media (max-width: 768px) {\n  .employee-header {\n    flex-direction: column;\n    gap: 1rem;\n    text-align: center;\n  }\n  \n  .employee-header h1 {\n    font-size: 1.5rem;\n    order: -1;\n  }\n  \n  .employee-nav {\n    flex-wrap: wrap;\n    padding: 1rem;\n    gap: 0.8rem;\n  }\n  \n  .nav-button {\n    flex: 1;\n    min-width: calc(50% - 0.4rem);\n    padding: 12px 16px;\n    font-size: 0.9rem;\n  }\n  \n  .employee-content {\n    padding: 0;\n  }\n}\n\n@media (max-width: 480px) {\n  .nav-button {\n    min-width: 100%;\n    margin-bottom: 0.5rem;\n  }\n  \n  .employee-header {\n    padding: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
